import { filterNulls } from "replo-utils/lib/array";

// NOTE (Kevin, 2025-12-15): Extension to MIME type mapping (single source of truth)
const EXTENSION_TO_MIME: Record<string, string> = {
  ".png": "image/png",
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".webp": "image/webp",
  ".svg": "image/svg+xml",
  ".gif": "image/gif",
  ".mp4": "video/mp4",
  ".mov": "video/quicktime",
  ".webm": "video/webm",
};

export const IMAGE_ACCEPT_FILE_EXTENSIONS = [
  ".png",
  ".jpg",
  ".jpeg",
  ".webp",
  ".svg",
  ".gif",
];

export const VIDEO_ACCEPT_FILE_EXTENSIONS = [".mp4", ".mov", ".webm"];

export const ACCEPT_FILE_EXTENSIONS = [
  ...IMAGE_ACCEPT_FILE_EXTENSIONS,
  ...VIDEO_ACCEPT_FILE_EXTENSIONS,
];

export const ACCEPT_FILE_TYPES = [
  ...ACCEPT_FILE_EXTENSIONS,
  ...Object.values(EXTENSION_TO_MIME),
];

// NOTE (Kevin, 2025-12-15): Chat excludes SVG because LLMs can only process raster
// images, and SVGs pose security risks (can contain embedded JavaScript).
const CHAT_FILE_EXTENSIONS = [
  ...IMAGE_ACCEPT_FILE_EXTENSIONS.filter((ext) => ext !== ".svg"),
  ...VIDEO_ACCEPT_FILE_EXTENSIONS,
];

const CHAT_IMAGE_MIME_TYPES = filterNulls(
  IMAGE_ACCEPT_FILE_EXTENSIONS.filter((ext) => ext !== ".svg").map(
    (ext) => EXTENSION_TO_MIME[ext],
  ),
);

const CHAT_VIDEO_MIME_TYPES = filterNulls(
  VIDEO_ACCEPT_FILE_EXTENSIONS.map((ext) => EXTENSION_TO_MIME[ext]),
);

export const CHAT_ACCEPT_MIME_TYPES = [
  ...CHAT_IMAGE_MIME_TYPES,
  ...CHAT_VIDEO_MIME_TYPES,
];

export const ALLOWED_CHAT_ASSET_TYPES = CHAT_FILE_EXTENSIONS.map((ext) => {
  return ext.slice(1);
});

export const CHAT_FILE_EXTENSIONS_DISPLAY = ALLOWED_CHAT_ASSET_TYPES.map(
  (ext) => ext.toUpperCase(),
);

export const IMAGE_EXTENSIONS_DISPLAY = IMAGE_ACCEPT_FILE_EXTENSIONS.filter(
  (ext) => ext !== ".svg",
).map((ext) => ext.slice(1).toUpperCase());

export const VIDEO_EXTENSIONS_DISPLAY = VIDEO_ACCEPT_FILE_EXTENSIONS.map(
  (ext) => ext.slice(1).toUpperCase(),
);

export const CHAT_FILE_ACCEPT_STRING = [
  ...CHAT_FILE_EXTENSIONS,
  ...CHAT_ACCEPT_MIME_TYPES,
].join(",");

export const MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
export const MAX_VIDEO_SIZE_BYTES = 250 * 1024 * 1024; // 250 MB
